<div class="dialog-wrappers">
    <div class="display-flex padding-dialog dialog-header">
        <div class="float-left">
            <div class="dialog-header-title">
                <h1>Roleplay Chat Session</h1>
                <span *ngIf="data.sessionId" class="session-tag">Session #{{ data.sessionId }}</span>
                <span *ngIf="history?.scenario_name" class="session-tag"> — {{ history.scenario_name }}</span>
            </div>
        </div>
        <div class="float-right">
            <span class="close-dialog" (click)="closeDialog()">
                <img src="../../../../assets/icons/icon-close.png" alt="Close" width="16" />
            </span>
        </div>
    </div>

    <mat-dialog-content>
        <div class="padding-dialog chat-container">
            <div *ngIf="isLoading" class="loading-state">Loading conversation...</div>

            <div *ngIf="!isLoading && conversations.length === 0" class="empty-state">
                No conversation messages found for this session.
            </div>

            <div *ngIf="!isLoading && conversations.length > 0" class="chat-window">
                <div *ngFor="let conv of conversations" class="chat-turn">
                    <!-- Coach message -->
                    <div class="left-side">
                    <div class="message-row coach" *ngIf="conv.coach_used && conv.question">
                        <div class="avatar">
                            <img src="../../../../assets/icons/coach-assist.svg" alt="Coach" />
                        </div>
                        <div class="bubble coach-bubble">
                            <div class="meta"><strong>Coach</strong> <span class="time">{{ conv.time }}</span></div>
                            <p>{{ conv.question }}</p>
                        </div>
                    </div>
                    </div>

                    <!-- User message -->
                    <div class="left-side">
                    <div class="message-row user" *ngIf="!conv.coach_used && conv.question">
                        <div class="avatar">
                            <img src="../../../../assets/images/JJMT_Icon_Web_Profile.png" alt="User" />
                        </div>
                        <div class="bubble user-bubble">
                            <div class="meta"><strong>{{ givenName }}</strong> <span class="time">{{ conv.time }}</span>
                            </div>
                            <p>{{ conv.question }}</p>
                        </div>
                    </div>
                    </div>

                    <!-- Bot response -->
                    <div class="right-side">
                    <div class="message-row bot" *ngIf="conv.answer">
                        <div class="avatar">
                            <img src="../../../../assets/images/chatbot-icon.svg" alt="AI" />
                        </div>
                        <div class="bubble bot-bubble">
                            <div class="meta"><strong>{{ history?.dr_name || 'AI' }}</strong> <span class="time">{{
                                    conv.time }}</span></div>
                            <p>{{ conv.answer }}</p>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>